import { Constants } from '../../../../../common/Constants';
import { ConstantsRoutes } from '../../../../../common/ConstantsRoutes';

export const parseBreadcrumbs = (urls, sectionType, t) => {
  const sectionTypeCondition =
    sectionType === Constants.RESULT_SECTION.PROVIDER
      ? t('Provider results')
      : t('Provider group results');
  const breadcrumbs = [
    {
      title:
        sectionType === Constants.RESULT_SECTION.FACILITY
          ? t('Facility results')
          : sectionTypeCondition,
      href: '',
    },
  ];
  if (urls[ConstantsRoutes.FACILITY_DETAILS.key]) {
    breadcrumbs.unshift({
      title: t('DETAILS_PAGE.FACILITY_BREADCRUMB'),
      href: `${urls[ConstantsRoutes.FACILITY_DETAILS.key]}`,
    });
  } else if (urls[ConstantsRoutes.PROVIDER_GROUP_DETAILS.key]) {
    breadcrumbs.unshift({
      title: t('DETAILS_PAGE.PROVIDER_GROUP_BREADCRUMB'),
      href: `${urls[ConstantsRoutes.PROVIDER_GROUP_DETAILS.key]}`,
    });
  } else if (urls[ConstantsRoutes.PROVIDER_DETAILS.key]) {
    breadcrumbs.unshift({
      title: t('DETAILS_PAGE.PROVIDER_BREADCRUMB'),
      href: `${urls[ConstantsRoutes.PROVIDER_DETAILS.key]}`,
    });
  }
  if (urls[ConstantsRoutes.PROVIDER_SEARCH_RESULTS.key]) {
    breadcrumbs.unshift({
      title: t('BC Results'),
      href: `${urls[ConstantsRoutes.PROVIDER_SEARCH_RESULTS.key]}`,
    });
  }
  return breadcrumbs;
};
